import { Box, Checkbox, Container, Flex, Table, Text } from '@mantine/core'
import ActionMenu from '@v2/commons/components/ActionMenu/ActionMenu.component'
import { addEmailDomainToUserModal } from '@v2/domains/emailDomain/components/AddEmailDomainToUserModal/AddEmailDomainToUserModal.component'
import { createEmailDomainModal } from '@v2/domains/emailDomain/components/CreateEmailDomainModal/CreateEmailDomainModal.component'
import { removeEmailDomainFromUserModal } from '@v2/domains/emailDomain/components/RemoveEmailDomainFromUser/RemoveEmailDomiainFromUser.component'
import { updateEmailDomainUserModal } from '@v2/domains/emailDomain/components/UpdateEmailDomainUserModal/UpdateEmailDomainUserModal.component'

import { Icons } from 'src/common/components'
import withErrorBoundaryAndPolicyCheck from 'src/v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'

import { IMembershipEmailDomainUser } from '../../user.types'
import styles from './membership-information.module.scss'

interface EmailDomainInformation {
  emailDomains: IMembershipEmailDomainUser[] | undefined
  userMembershipId: string
}

const EmailDomainInformation = ({
  emailDomains,
  userMembershipId,
}: EmailDomainInformation) => {
  return (
    <Box my="md">
      <Flex
        justify="space-between"
        align="flex-start"
        className={styles.headerWrapper}
      >
        <Text fw={700} c="blue.5">
          Email Domail
        </Text>
        <ActionMenu
          menuItems={[
            {
              label: 'Create New Email Domain',
              color: 'blue',
              icon: <Icons.Plus width="20" />,
              onClick: () => createEmailDomainModal(),
              enable: true,
            },
            {
              label: 'Add new email domain to user',
              color: 'blue',
              icon: <Icons.Edit />,
              onClick: () => addEmailDomainToUserModal(userMembershipId),
              enable: true,
            },
          ]}
        />
      </Flex>

      <Flex justify="center">
        <Container mx="md" className={styles.flex1} my="xl">
          <Table withTableBorder highlightOnHover withColumnBorders>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Email/Domain</Table.Th>
                <Table.Th>Name/Title</Table.Th>
                <Table.Th>Direction</Table.Th>
                <Table.Th>Is Registered</Table.Th>
                <Table.Th></Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {emailDomains?.map((emailDomanin) => (
                <Table.Tr key={emailDomanin.id}>
                  <Table.Td>{emailDomanin.domain}</Table.Td>
                  <Table.Td>{emailDomanin.name}</Table.Td>
                  <Table.Td>{emailDomanin.type}</Table.Td>
                  <Table.Td>
                    <Checkbox checked={emailDomanin.isWBFRegister} readOnly />
                  </Table.Td>
                  <Table.Td>
                    <ActionMenu
                      menuItems={[
                        {
                          label: 'Update',
                          color: 'blue',
                          icon: <Icons.Edit />,
                          onClick: () =>
                            updateEmailDomainUserModal(
                              emailDomanin,
                              userMembershipId,
                            ),
                          enable: true,
                        },
                        {
                          label: 'Delete',
                          color: 'red',
                          icon: <Icons.Trash />,
                          onClick: () =>
                            removeEmailDomainFromUserModal(emailDomanin.id),
                          enable: true,
                        },
                      ]}
                    />
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Container>
      </Flex>
    </Box>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  EmailDomainInformation,
  'is_enable_leads_table',
  true,
)
